import React from 'react';
import PropTypes from 'prop-types';
import TachyReport from 'containers/TachyReport/TachyReport';
import { DOCTOR, RESEARCHER, SUPER_RESEARCHER, SUPER_TECHNICIAN } from 'constants/userRoles';

const TachyReportWithRole = ({ role }) => (
  <>{[DOCTOR, RESEARCHER, SUPER_RESEARCHER, SUPER_TECHNICIAN].includes(role) && <TachyReport />}</>
);

TachyReportWithRole.propTypes = {
  role: PropTypes.string.isRequired,
};

export default TachyReportWithRole;
